import { Routes, Route } from 'react-router-dom'
import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute'

import { LandingPage } from '@/features/landing/pages/LandingPage'
import { LoginPage } from '@/features/auth/pages/LoginPage'
import { SignupPage } from '@/features/auth/pages/SignupPage'
import { VerifyOTPPage } from '@/features/auth/pages/VerifyOTPPage'
import { OnboardingPage } from '@/features/onboarding/pages/OnboardingPage'
import { DashboardPage } from '@/features/dashboard/pages/DashboardPage'
import { ProfilePage } from '@/features/dashboard/pages/ProfilePage'
import { InventoryPage } from '@/features/inventory/pages/InventoryPage'
import { OrdersPage } from '@/features/orders/pages/OrdersPage'

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<SignupPage />} />
      <Route path="/verify-otp/:phone" element={<VerifyOTPPage />} />
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route
        path="/dashboard/:vendorId"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/:vendorId/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory/:vendorId"
        element={
          <ProtectedRoute>
            <InventoryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders/:vendorId"
        element={
          <ProtectedRoute>
            <OrdersPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}
